window.onerror = function (msg, url, line) {
  console.log("ERROR DETECTADO:", msg, "linea:", line);
};

// ==========================
// ⚙️ CONFIG
// ==========================
const coachConfig = {
  url: "https://script.google.com/macros/s/AKfycbztmc_Z7ZvFCFBe2Q_JAW1eTZgaKlo2iQ8wmLagxpt2DtkxS4JVZ1D73wsqQ9SZoEB4kw/exec"
};

const avatarIdle = "https://cdn.shopify.com/s/files/1/0997/7036/8294/files/coach-idle.png?v=1776187239";
const avatarTalk = "https://cdn.shopify.com/s/files/1/0997/7036/8294/files/coach-talk.png?v=1776187239";

// ==========================
// 🧠 ESTADO GLOBAL
// ==========================
let state = "inicio";

// ==========================
// 🚀 INIT
// ==========================
document.addEventListener("DOMContentLoaded", () => {
  const body = document.getElementById("coach-chat-body");
  const coach = document.getElementById("coach-container");
  const bubble = document.getElementById("coach-bubble");

  if (!body || !coach || !bubble) return;

  iniciarCoach();

  coach.style.display = "none";
  bubble.style.display = "flex";
});

// ==========================
// UI
// ==========================
function abrirCoach() {
  document.getElementById("coach-container").style.display = "flex";
  document.getElementById("coach-bubble").style.display = "none";
}

function cerrarCoach() {
  document.getElementById("coach-container").style.display = "none";
  document.getElementById("coach-bubble").style.display = "flex";
}

// ==========================
// INICIO
// ==========================
function iniciarCoach() {
  state = "inicio";

  renderCoachMsg("👋 Soy tu coach. ¿Qué quieres medir?", `
    <div class="coach-buttons-group">
      <button class="coach-quick-reply" onclick="setFlow('tachones')">
        <span>👟</span> Tachones
      </button>
      <button class="coach-quick-reply" onclick="setFlow('guantes')">
        <span>🧤</span> Guantes
      </button>
      <button class="coach-quick-reply" onclick="setFlow('cascos')">
        <span>🪖</span> Cascos
      </button>
    </div>
  `);
}

// ==========================
// FLOW
// ==========================
function setFlow(type) {
  localStorage.setItem("product", type);
  userSays(type);

  if (type === "tachones") {
    state = "tachones_inicio";
    renderCoachMsg("¿Sabes cuánto mide tu pie?", `
      <div class="coach-buttons-group">
        <button class="coach-quick-reply" onclick="tachonesMedida(true)">
          <span>✅</span> Sí
        </button>
        <button class="coach-quick-reply" onclick="tachonesMedida(false)">
          <span>❌</span> No
        </button>
      </div>
    `);
  }

  if (type === "guantes") {
    state = "guantes_inicio";
    renderCoachMsg("¿Ya mediste tu mano?", `
      <div class="coach-buttons-group">
        <button class="coach-quick-reply" onclick="guantesMedida(true)">
          <span>✅</span> Sí
        </button>
        <button class="coach-quick-reply" onclick="guantesMedida(false)">
          <span>❌</span> No
        </button>
      </div>
    `);
  }

  if (type === "cascos") {
    state = "cascos_inicio";
    renderCoachMsg("¿Sabes la medida de tu cabeza?", `
      <div class="coach-buttons-group">
        <button class="coach-quick-reply" onclick="cascosMedida(true)">
          <span>✅</span> Sí
        </button>
        <button class="coach-quick-reply" onclick="cascosMedida(false)">
          <span>❌</span> No
        </button>
      </div>
    `);
  }
}

// ==========================
// TACHONES
// ==========================
function tachonesMedida(sabe) {
  userSays(sabe ? "Sí" : "No");

  if (!sabe) {
    renderCoachMsg("Pon tu pie en una hoja contra la pared y mide en cm.", `
      <div class="coach-buttons-group">
        <button class="coach-quick-reply" onclick="tachonesMedida(true)">
          <span>📏</span> Ya lo medí
        </button>
      </div>
    `);
    return;
  }

  state = "tachones_input";
  renderCoachMsg("Dime cuántos cm mide tu pie 👇");
}

// ==========================
// GUANTES
// ==========================
function guantesMedida(sabe) {
  userSays(sabe ? "Sí" : "No");

  if (!sabe) {
    renderCoachMsg("Mide tu mano desde la palma al dedo medio.", `
      <div class="coach-buttons-group">
        <button class="coach-quick-reply" onclick="guantesMedida(true)">
          <span>📏</span> Ya lo medí
        </button>
      </div>
    `);
    return;
  }

  state = "guantes_input";
  renderCoachMsg("¿Cuántos cm mide tu mano?");
}

// ==========================
// CASCOS
// ==========================
function cascosMedida(sabe) {
  userSays(sabe ? "Sí" : "No");

  if (!sabe) {
    renderCoachMsg("Mide tu cabeza 2 cm arriba de las cejas.", `
      <div class="coach-buttons-group">
        <button class="coach-quick-reply" onclick="cascosMedida(true)">
          <span>📏</span> Ya lo medí
        </button>
      </div>
    `);
    return;
  }

  state = "cascos_input";
  renderCoachMsg("¿Cuántos cm mide tu cabeza?");
}

// ==========================
// INPUT
// ==========================
window.processInput = async function () {
  const input = document.getElementById("coach-user-input");
  const val = input.value.trim();
  if (!val) return;

  userSays(val);
  input.value = "";

  const typingId = renderTyping();

  if (state === "tachones_input") {
    removeTyping(typingId);
    const talla = Math.ceil(parseFloat(val) + 0.5);
    renderCoachMsg(`🔥 Tu talla es ${talla} MX`);
    return;
  }

  if (state === "guantes_input") {
    removeTyping(typingId);
    const cm = parseFloat(val);
    const talla = cm <= 18 ? "S" : cm <= 20 ? "M" : "L";
    renderCoachMsg(`🧤 Tu talla es ${talla}`);
    return;
  }

  if (state === "cascos_input") {
    removeTyping(typingId);
    const cm = parseFloat(val);
    const talla = cm <= 54 ? "S" : cm <= 57 ? "M" : cm <= 59 ? "L" : "XL";
    renderCoachMsg(`🪖 Tu talla es ${talla}`);
    return;
  }

  removeTyping(typingId);
  renderCoachMsg("Te conecto con un especialista 👇");
};

// ==========================
// RENDER
// ==========================
function renderCoachMsg(text, buttons = "") {
  const body = document.getElementById("coach-chat-body");
  const avatar = document.getElementById("coach-avatar");

  if (avatar) avatar.src = avatarTalk;

  const div = document.createElement("div");
  div.className = "chat-message message-coach";

  div.innerHTML = text;

  if (buttons) {
    const btnWrap = document.createElement("div");
    btnWrap.innerHTML = buttons;
    div.appendChild(btnWrap);
  }

  const globalWrap = document.createElement("div");
  globalWrap.innerHTML = globalButtons();
  div.appendChild(globalWrap);

  body.appendChild(div);
  body.scrollTop = body.scrollHeight;

  setTimeout(() => avatar.src = avatarIdle, 1200);
}

// ==========================
// USER
// ==========================
function userSays(text) {
  const body = document.getElementById("coach-chat-body");
  const div = document.createElement("div");
  div.className = "chat-message message-user";
  div.innerText = text;
  body.appendChild(div);
}

// ==========================
// TYPING
// ==========================
function renderTyping() {
  const body = document.getElementById("coach-chat-body");
  const div = document.createElement("div");
  div.className = "chat-message message-coach";
  div.id = "typing";
  div.innerHTML = "⏳ Escribiendo...";
  body.appendChild(div);
  return "typing";
}

function removeTyping(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

// ==========================
// BOTONES
// ==========================
function globalButtons() {
  return `
    <div class="coach-buttons-group">
      <button class="coach-quick-reply" onclick="contactar()">
        <span>📲</span> WhatsApp
      </button>
      <button class="coach-quick-reply" onclick="iniciarCoach()">
        <span>🔄</span> Reiniciar
      </button>
    </div>
  `;
}

// ==========================
// EXTRA
// ==========================
function contactar() {
  window.open("https://wa.me/5216141077235");
}

function checkEnter(e) {
  if (e.key === "Enter") {
    e.preventDefault();
    processInput();
  }
}

// ==========================
// FIX GLOBAL
// ==========================
window.setFlow = setFlow;
window.tachonesMedida = tachonesMedida;
window.guantesMedida = guantesMedida;
window.cascosMedida = cascosMedida;
window.iniciarCoach = iniciarCoach;
window.contactar = contactar;
window.abrirCoach = abrirCoach;
window.cerrarCoach = cerrarCoach;